module.exports = __webpack_public_path__ + "static/media/left.f35a3e98.svg";